/**
 * MaizeSalesTab — Bulk maize sales to buyers with Edit/Delete actions.
 */
import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Button } from '../ui/button';
import { Pencil, Trash2 } from 'lucide-react';
import { formatCurrency, formatNumber, formatDate } from '../../lib/utils';

const MaizeSalesTab = ({ sales = [], canEdit = false, onEdit, onDelete }) => (
  <Card>
    <CardContent className="p-0">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Buyer</TableHead>
            <TableHead>Quantity</TableHead>
            <TableHead>Price/kg</TableHead>
            <TableHead className="text-right">Total</TableHead>
            {canEdit && <TableHead className="text-right">Actions</TableHead>}
          </TableRow>
        </TableHeader>
        <TableBody>
          {sales.length === 0 ? (
            <TableRow>
              <TableCell colSpan={canEdit ? 6 : 5} className="text-center py-8 text-muted-foreground">
                No sales recorded yet
              </TableCell>
            </TableRow>
          ) : (
            sales.map((sale) => (
              <TableRow key={sale.id} className="table-row-hover">
                <TableCell>{formatDate(sale.date)}</TableCell>
                <TableCell className="font-medium">{sale.buyer_name}</TableCell>
                <TableCell>{formatNumber(sale.quantity_kg)} kg</TableCell>
                <TableCell>{formatCurrency(sale.price_per_kg)}</TableCell>
                <TableCell className="text-right font-medium text-blue-600">
                  {formatCurrency(sale.total_amount)}
                </TableCell>
                {canEdit && (
                  <TableCell className="text-right">
                    <div className="flex items-center justify-end gap-1.5">
                      <Button size="sm" variant="outline" onClick={() => onEdit?.(sale)} data-testid={`edit-sale-${sale.id}`} className="h-8 px-2.5">
                        <Pencil className="h-3.5 w-3.5 mr-1" />Edit
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => onDelete?.(sale)} data-testid={`delete-sale-${sale.id}`} className="h-8 px-2.5 border-destructive/40 text-destructive hover:bg-destructive/10 hover:text-destructive">
                        <Trash2 className="h-3.5 w-3.5 mr-1" />Delete
                      </Button>
                    </div>
                  </TableCell>
                )}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </CardContent>
  </Card>
);

export default MaizeSalesTab;
